import React from 'react';
import { hasEnquiryOccasion } from './enquiryOccasionHelper';

const NoBookingsAvailable = ({ allOccasions, selectedArea, onChangeToEnquiry, phone, restaurantName, selectedDay, selectedMonth, selectedYear }) => {  

    if (!selectedArea?.areaLinkGroup?.areaLinks?.[0] || !phone) {
        return null;
    }

    const makeEnquiryValid = () => {
        var now = new Date();
        if (now.getDate() == selectedDay && now.getMonth() == selectedMonth && now.getFullYear() == selectedYear) {
            return false;
        }
        return hasEnquiryOccasion(allOccasions, selectedArea);
    }

    const formatPhoneNumber = (phone) => {
        phone = phone.toString().replace("+", "").replace("44", "0")
        var phoneSplit = [phone.substring(0, 3), phone.substring(3, 7), phone.substring(7, 11)];
        var formattedNumber = phoneSplit.join(' ');
        return formattedNumber;
    }


    return (
        <>
            <style>
                {`

                .inactive button{
                    background-color: white;
                    color: black;
                    width: 50px;
                    padding: 5px;
                    margin: 5px;
                }

                
                .active button{
                    background-color: green;
                    color: white;
                    width: 50px;
                    padding: 5px;
                    margin: 5px;
                }
                `}
            </style>

            <div className='p-4 w-full bg-tomato text-off-white mt-5'>
                <div className='flex gap-2 justify-center'>
                    <div className="box-icon items-center flex">
                        <img src="/icons/common/offwhite/alert-circle.svg" alt="alert" />
                    </div>
                    <div className='mb-0 text-center'>Sorry, your preferred time isn't available.</div>
                </div>
            </div>
            <div className='flex justify-center gap-2 text-basil text-lg mt-12'>
                <span>Call Prezzo {restaurantName} on </span>

                <a href={'tel:' + phone.toString().replace("44", "0")} className='flex gap-2 items-center'>
                    <div className='box-icon w-5 h-5'>
                        <img alt="phone icon" className="icon" src="/icons/restaurants/phone-call.svg" />
                    </div>
                    <div>
                        {formatPhoneNumber(phone)}
                    </div>
                </a>
            </div>

            {makeEnquiryValid() &&
                <div className="mt-5">
                    <span>If you'd rather be contacted by a member of our team, please submit an enquiry using the button below.</span>
                    <div className="mt-6 flex justify-center">
                        <button type="button" className="button" onClick={() => onChangeToEnquiry()}>Make an Enquiry</button>
                    </div>
                </div>
            }
            
        </>);

}

export default NoBookingsAvailable;